import React, { useMemo, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import useChallengeWireSummary from '../../hooks/useChallengeWireSummary';
import { landingDestinationBadgeCount } from '../../utils/landingPageChallengeBadge';
import { filterHubNavigationItems } from '../../utils/hubNavigation';

const LANDING_PAGE_DESTINATIONS = [
	{
		id: 'nutrition-lab',
		path: '/nutrition-lab',
		title: 'Nutrition Lab',
		icon: '🥗'
	},
	{
		id: 'fitness-hub',
		path: '/fitness-hub',
		title: 'Fitness Hub',
		icon: '🏋️',
		badgeKey: 'challenges'
	},
	{
		id: 'classroom',
		path: '/classroom',
		title: 'The Classroom',
		icon: '🧑‍🏫'
	},
	{
		id: 'best-ball-zone',
		path: '/best-ball-zone',
		title: 'Best Ball Zone',
		icon: '🎯'
	},
	{
		id: 'front-office',
		path: '/front-office',
		title: 'Front Office',
		icon: '💼'
	}
];

function DestinationIcon({ destination, badge }) {
	return (
		<div
			className="relative w-12 h-12 flex items-center justify-center bg-blue-600 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
			onClick={() => (window.location.href = destination.path)}
			title={destination.title}
		>
			<span aria-hidden>{destination.icon}</span>
			{badge > 0 && (
				<span className="absolute -top-1 -right-1 flex h-4 items-center justify-center rounded-full bg-red-500 px-1 text-xs font-normal leading-none text-white">
					{badge > 9 ? '9+' : badge}
				</span>
			)}
		</div>
	);
}

export default function LandingPageExitMenu({
	currentPage,
	summary: summaryProp,
	triggerTitle = 'Open navigation',
	triggerClassName,
	containerClassName
}) {
	const { user, endpoints, csrfToken, fitnessHubsOnly } = useAuth();
	const summaryFromHook = useChallengeWireSummary(user, endpoints, csrfToken, {
		enabled: summaryProp === undefined
	});
	const summary = summaryProp ?? summaryFromHook;
	const [
		isOpen,
		setIsOpen
	] = useState(false);

	const visibleDestinations = useMemo(
		() =>
			filterHubNavigationItems(
				LANDING_PAGE_DESTINATIONS.filter(
					(destination) => destination.id !== currentPage
				),
				fitnessHubsOnly
			),
		[currentPage, fitnessHubsOnly]
	);

	return (
		<div className={containerClassName || 'relative flex items-center'}>
			{isOpen && (
				<div className="absolute bottom-full left-1/2 mb-3 flex -translate-x-1/2 transform flex-col items-center space-y-3 rounded-2xl bg-black/60 p-2 backdrop-blur-md">
					{visibleDestinations.map((destination) => (
						<DestinationIcon
							key={destination.id}
							destination={destination}
							badge={landingDestinationBadgeCount(destination, summary)}
						/>
					))}
				</div>
			)}
			<div
				className={
					triggerClassName ||
					'w-12 h-12 flex items-center justify-center bg-blue-600 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md'
				}
				onClick={() => setIsOpen((open) => !open)}
				title={triggerTitle}
			>
				➡️
			</div>
		</div>
	);
}
